import React from 'react';
import { useParams } from 'react-router-dom';
import VCFViewer from './components/VCFViewer';
import globalStyle from './global.module.css';

const App = () => {
    const { filename } = useParams();

    return (
        <div className={globalStyle.centered}>
            <VCFViewer filename={filename}/>
        </div>
    );
}

export default App;